/**
 * Волна C (docs/MIGRATION_ROUTER.md §5). Было: <PrivateRoute path='/loyalty-program'>.
 */
import { createFileRoute } from '@tanstack/react-router';
import CacheDataRoute from '../CacheDataRoute';
import LoyaltyProgram from '@routes/StaticPages/LoyaltyProgram';

export const Route = createFileRoute('/loyalty-program')({
  component: () => <CacheDataRoute component={LoyaltyProgram} path='/loyalty-program' />
});
